/**
 * Created by User on 10/5/2016.
 */
import PageComponent from '../base/PageComponent';
import 'slick-carousel';
import createHistory from 'history/createBrowserHistory';

export default class ProductSearchForm extends PageComponent {
    constructor(element) {
        super(element);
    }

    init(){
        this.history = createHistory();
        this.history.listen((location, action) => this.search(location));

        this.element.on('submit', e => this.handleFormSubmit(e));
        this.productsPage.on('click', '.pager a', e => this.handlePagingClick(e));

        this.setupCarousel();
    }

    setProductsPage(page) {
        this.productsPage = page;
        return this;
    }

    handlePagingClick(e) {
        e.preventDefault();
        this.history.push($(e.target).attr('href'))
    }

    handleFormSubmit(e) {
        e.preventDefault();
        let target = $(e.target),
            url = target.attr('action') +
                '?' + this.getSearchParams();
        this.history.push(url);
    }

    /**
     * Performs the search by making ajax request. Triggered by a history update.
     *
     * @param {object} location Location object from history api.
     * @param {string} action
     */
    search(location, action){
        let url = location.pathname + location.search,
            headers = new Headers(),
            resultsContainer = this.getResultsContainer();

        // make sure server picks up request as ajax
        headers.append("X-Requested-With", "XMLHttpRequest");

        resultsContainer.addClass('loading');
        fetch(url, {
            method: 'GET',
            headers: headers,
        }).then(response => {
            return response.json();
        }).then(json => {
            resultsContainer.html(json.Content).removeClass('loading');
            this.setupCarousel();
            this.scrollTo(resultsContainer, this.getStickyElement().height())
        });
    }

    /**
     * Gets the container to insert results.
     *
     * return {HTMLElement}
     */
    getResultsContainer() {
        return this.productsPage.find('.productResults');
    }

    getSearchParams() {
        return 'OuterDiameter=' + $('#Form_ProductSearchForm_OuterDiameter').val() +
        '&FilterLength=' + $('#Form_ProductSearchForm_FilterLength').val()
    }

    setupCarousel() {
        $('.product__imgs').each(function(){
            $(this).slick({
                slide: '.product__img',
                autoplay: false,
                adaptiveHeight: false,
                dots: true,
                speed: 1,
                appendDots: $(this),
                customPaging: function (slider, i) {
                    var thumb = $(slider.$slides[i]).data('thumb');
                    return '<span></span>';
                },
                slidesToShow: 1,
                infinite: false,
                arrows: false
            });
        });

        $('.slick-dots').on('click', e => this.carouselChange(e));
    }

    carouselChange(e){
        $('.zoomContainer').remove();
        $('#elevate-zoomr').removeData('elevateZoom');
    }

    /**
     * Change this to a sticky element so we can offset this when scrolling.
     *
     * @returns {*|jQuery|HTMLElement}
     */
    getStickyElement() {
        return $('.site__nav.sticky');
    }
}


// WEBPACK FOOTER //
// ./src/js/components/ProductSearchForm.js